export default {
	GET: () => "/settings",
	UPDATE: () => "/settings",
};
